export const ru = {
  operations: {
    backups: {
      title: 'Резервные копии',
      subtitle: 'Полная копия платформы — база и файлы медиа. Скачайте её перед переездом и восстановите на другом сервере.',
      demo: 'В демо копии ничего не делают с данными: создание только показывает ход, файл не появляется, а загруженный файл не сохраняется и не применяется.',
      newTitle: 'Новая копия',
      contents:
        'В копию входят пользователи и сессии, блоги, посты, справочники, медиа и их файлы, каналы и планирование, история публикаций, настройки платформы и тарифы. Не входят настройки окружения сервера и сами резервные копии.',
      create: 'Создать резервную копию',
      busy: 'Сейчас идёт создание копии или восстановление — новое можно начать после его окончания.',
      upload: 'Загрузить копию',
      uploadHint: 'Файл gr_backup_….zip, скачанный на другом сервере. Копию больше 4 ГБ положите в каталог backups хранилища файлов — она появится в списке.',
      uploading: 'Загрузка {name} — {percent}%',
      uploaded: 'Копия {name} загружена. Восстановите её кнопкой «Восстановить» в списке.',
      uploadedDemo: 'В демо файл не загружается и не применяется.',
      listTitle: 'Копии',
      empty: 'Копий пока нет',
      emptyText: 'Создайте копию или загрузите файл копии с другого сервера.',
      table: 'Резервные копии',
      columns: {
        name: 'Копия',
        added: 'Когда',
        size: 'Объём',
        contents: 'Содержимое',
        version: 'Версия',
        actions: 'Действия',
      },
      origins: {
        created: 'Создана здесь',
        uploaded: 'Загружена',
        added: 'Положена вручную',
      },
      by: '{name}',
      summary: 'Пользователей: {users} · блогов: {blogs} · постов: {posts} · медиа: {media}',
      files: 'Файлов: {files}, {bytes}',
      missing: { one: 'не хватало {n} файла', few: 'не хватало {n} файлов', many: 'не хватало {n} файлов', other: 'не хватало {n} файла' },
      invalid: 'Не читается как копия',
      compatibility: {
        same: 'Эта версия',
        older: 'Прошлая версия — данные обновятся',
        newer: 'Новее сайта — сначала обновите сайт',
        invalid: 'Не копия',
      },
      download: 'Скачать',
      restore: 'Восстановить',
      delete: 'Удалить',
      restoreConfirm: 'Восстановить из копии «{name}»?',
      restoreText:
        'База и файлы медиа этой установки заменятся содержимым копии от {date}. Всё, что сделано после неё и во время восстановления, пропадёт. Пользователи и сессии будут из копии: войдите заново учётной записью из неё.',
      deleteConfirm: 'Удалить копию «{name}»?',
      deleteText: 'Файл копии удалится из хранилища, вернуть его нельзя.',
      report: {
        archive: 'Архив: {name}, {size}',
        archived: 'Файлов медиа: {files}, {bytes}',
        missing: { one: 'Пропал {n} файл — в копию не попал', few: 'Пропало {n} файла — в копию не попали', many: 'Пропало {n} файлов — в копию не попали', other: 'Пропало {n} файла — в копию не попали' },
        demo: 'Демо: файл копии не создаётся.',
        source: 'Из копии {name}, версия сайта {version}',
        migrated: { one: 'Данные обновлены {n} миграцией', few: 'Данные обновлены {n} миграциями', many: 'Данные обновлены {n} миграциями', other: 'Данные обновлены {n} миграциями' },
        restored: 'Файлов записано: {restored}, уже были на месте: {unchanged}, с ошибками: {failed}',
        removed: 'Удалено файлов прежней базы: {n}',
        relogin: 'Пользователи и сессии теперь из копии — если сайт попросит войти, войдите учётной записью из копии.',
      },
    },
  },
};

export const en: typeof ru = {
  operations: {
    backups: {
      title: 'Backups',
      subtitle: 'A full copy of the platform — the database and media files. Download it before moving and restore it on another server.',
      demo: 'In the demo, backups do nothing to the data: creating one only shows the progress, no file appears, and an uploaded file is neither saved nor applied.',
      newTitle: 'New backup',
      contents:
        'A backup includes users and sessions, blogs, posts, references, media and their files, channels and scheduling, publication history, platform settings and plans. It does not include the server environment settings or the backups themselves.',
      create: 'Create a backup',
      busy: 'A backup or a restore is running — a new one can be started when it finishes.',
      upload: 'Upload a backup',
      uploadHint: 'A gr_backup_….zip file downloaded on another server. Put a backup larger than 4 GB into the backups folder of the file storage — it will appear in the list.',
      uploading: 'Uploading {name} — {percent}%',
      uploaded: 'Backup {name} is uploaded. Restore it with “Restore” in the list.',
      uploadedDemo: 'In the demo the file is neither uploaded nor applied.',
      listTitle: 'Backups',
      empty: 'No backups yet',
      emptyText: 'Create a backup or upload a backup file from another server.',
      table: 'Backups',
      columns: {
        name: 'Backup',
        added: 'When',
        size: 'Size',
        contents: 'Contents',
        version: 'Version',
        actions: 'Actions',
      },
      origins: {
        created: 'Created here',
        uploaded: 'Uploaded',
        added: 'Added manually',
      },
      by: '{name}',
      summary: 'Users: {users} · blogs: {blogs} · posts: {posts} · media: {media}',
      files: 'Files: {files}, {bytes}',
      missing: { one: '{n} file was missing', few: '{n} files were missing', many: '{n} files were missing', other: '{n} files were missing' },
      invalid: 'Not readable as a backup',
      compatibility: {
        same: 'This version',
        older: 'Older version — data will be updated',
        newer: 'Newer than the site — update the site first',
        invalid: 'Not a backup',
      },
      download: 'Download',
      restore: 'Restore',
      delete: 'Delete',
      restoreConfirm: 'Restore from backup “{name}”?',
      restoreText:
        'The database and media files of this installation will be replaced with the backup from {date}. Everything done after it and during the restore will be lost. Users and sessions will come from the backup: sign in again with an account from it.',
      deleteConfirm: 'Delete backup “{name}”?',
      deleteText: 'The backup file will be deleted from the storage and cannot be recovered.',
      report: {
        archive: 'Archive: {name}, {size}',
        archived: 'Media files: {files}, {bytes}',
        missing: { one: '{n} file was missing and is not in the backup', few: '{n} files were missing and are not in the backup', many: '{n} files were missing and are not in the backup', other: '{n} files were missing and are not in the backup' },
        demo: 'Demo: no backup file is created.',
        source: 'From backup {name}, site version {version}',
        migrated: { one: 'Data updated by {n} migration', few: 'Data updated by {n} migrations', many: 'Data updated by {n} migrations', other: 'Data updated by {n} migrations' },
        restored: 'Files written: {restored}, already in place: {unchanged}, with errors: {failed}',
        removed: 'Files of the previous database deleted: {n}',
        relogin: 'Users and sessions now come from the backup — if the site asks you to sign in, use an account from the backup.',
      },
    },
  },
};
